import { useQuery } from '@tanstack/react-query'
import { baseUrl } from 'api/config'
import axios from 'axios'

export const useOrgMonthlyProgress = (orgId: string) => {
  return useQuery({
    queryKey: ['orgMonthlyProgress', orgId],
    queryFn: async () => {
      const res = await axios.get(`${baseUrl}/aws/organizations/${orgId}/monthly-progress`)
      return res.data
    },
    enabled: !!orgId || orgId === 'null',
  })
}
